import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material'
import React from 'react'
import CustomAlert from '../_WMS/AlertMessage/AlertMessage'
import { Warning } from '@mui/icons-material'

interface ComponentProps {
  ResetConfirmOpen: boolean
  HandleCancelReset: () => void
  HandleReset: () => void
}

export const ModalConfirmReset: React.FC<ComponentProps> = ({
  ResetConfirmOpen,
  HandleCancelReset,
  HandleReset
}) => {
  return (
    <Dialog
      open={ResetConfirmOpen}
      onClose={HandleCancelReset}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>
        Confirmar Reinicio Captura de Servicio VAS
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          <CustomAlert
            severity='warning'
            icon={<Warning />}
            message={'Todos los datos capturados hasta ahora serán borrados.'}
          />
          ¿Estás seguro de que deseas reiniciar la Captura de Servicio VAS? Esta
          acción no se puede deshacer.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={HandleCancelReset} color='default'>
          Cancelar
        </Button>
        <Button onClick={HandleReset} color='secondary' autoFocus>
          Reiniciar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
